export const CREATE_ROOM = 'CREATE_ROOM';
export const MODIFY_PLAYERS = 'MODIFY_PLAYERS';
export const INCREMENT_ROUND = 'INCREMENT_ROUND';
export const MODIFY_QUESTIONS = 'MODIFY_QUESTIONS';
export const MODIFY_MODE = 'MODIFY_MODE';
export const MODIFY_ANSWERS = 'MODIFY_ANSWERS';
export const INCREMENT_INDEX = 'INCREMENT_INDEX';